import {
  commissionFields,
  commissionLayoutRow,
} from '../../shared/cards/commissionFields';
import { personalDealField } from '../../shared/cards/complianceUpstreamFields';
import type { CoverSheetConfigCard } from '../../types';

export const commissionDetailsCard = {
  id: 'propertyInfo.commissionDetails',
  innerTitle: 'Commission Details',
  layout: [
    commissionLayoutRow('commission'),
    commissionLayoutRow('counterpartyCommission'),
    [{ name: 'isPersonalDeal', size: 25, mobileSize: 50 }],
  ],
  fields: {
    // Sell side
    ...commissionFields('commission', {
      label: 'Listing Agent Compensation',
      additionalLabel: 'Additional Listing Agent Compensation',
    }),
    // Buy side
    ...commissionFields('counterpartyCommission', {
      label: 'Buyer’s Agent Compensation',
      additionalLabel: 'Additional Buyer’s Agent Compensation',
    }),
    isPersonalDeal: personalDealField,
  },
} satisfies CoverSheetConfigCard;
